import CreateEditScheduleForm from './component'

export default CreateEditScheduleForm